import React from "react";
import { Box, Typography, Grid, Chip, Paper } from "@mui/material";
import Icon from "./Icons";
import { displayPatientName } from "../../../utils/displayPatientName";

export default function PatientSummaryModal({
  patientSummary,
  totalRecords,
  isLoadingSummary,
}) {
  return (
    <>
      {patientSummary &&
      patientSummary?.patient_demographics?.patient_name &&
      patientSummary?.patient_demographics?.patient_name.length > 0 ? (
        <Box sx={{ p: 2 }}>
          {/* ----------------- Patient History Section ----------------- */}

          <Paper
            elevation={0}
            sx={{
              borderRadius: "12px",
              p: 3,
              mb: 2,
              border: "1px solid #C7C7CC",
            }}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" mb={2}>
                <Icon name="patientDetailsInSummary" size={20} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, fontSize: "18px", marginLeft: "2px" }}
                >
                  Patients’ History:
                </Typography>
              </Box>

              <Box textAlign="right">
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#6a6a6a",
                    marginTop: "5px",
                  }}
                >
                  {patientSummary?.patient_demographics?.patient_id}
                </Typography>
              </Box>
            </Box>

            <DetailsRow
              label="Patient Name"
              value={displayPatientName(
                patientSummary?.patient_demographics?.patient_name
              )}
            />

            <DetailsRow
              label="Gender"
              value={patientSummary?.patient_demographics?.gender}
            />

            <DetailsRow
              label="Type of Visit"
              value={patientSummary?.patient_demographics?.type_of_visit}
            />

            <DetailsRow label="Total Records" value={totalRecords} />
          </Paper>

          {/* ----------------- Medical History Section ----------------- */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: "12px",
              p: 3,
              backgroundColor: "#E9F5FE",
              border: "1px solid #99CFF9",
            }}
          >
            <Box display="flex" alignItems="center" mb={2}>
              <Icon name="medicalHistoryInSummary" size={20} />
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, fontSize: "18px", marginLeft: "2px" }}
              >
                Medical History:
              </Typography>
            </Box>

            <MedicalRow
              label="Disease History"
              value={patientSummary?.disease_history}
            />

            <MedicalRow
              label="Treatment History"
              value={patientSummary?.treatment_history}
            />

            <MedicalRow
              label="Abnormality Highlights"
              value={patientSummary?.abnormality_highlights}
            />

            <MedicalRow
              label="Drug History"
              value={patientSummary?.drug_history}
            />

            <MedicalQuestionsRow
              label="Five Questions To Ask"
              value={patientSummary?.five_questions?.split(";")}
            />
          </Paper>
        </Box>
      ) : isLoadingSummary ? (
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography>Summary is Loading...</Typography>
        </div>
      ) : (
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Icon name="noRecordsFound" size={80} />
        </div>
      )}
    </>
  );
}

/* ---------------- Reusable Row Components ---------------- */
const MedicalRow = ({ label, value }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        py: 1.5,
        borderBottom: "1px solid #dbe4ec",
      }}
    >
      <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
      <Box sx={{ maxWidth: "70%", textAlign: "right" }}>
        {typeof value === "string" ? (
          <Typography sx={{ fontSize: 14, textAlign: "justify" }}>
            {value}
          </Typography>
        ) : (
          value
        )}
      </Box>
    </Box>
  );
};
const MedicalQuestionsRow = ({ label, value }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        py: 1.5,
        borderBottom: "1px solid #dbe4ec",
      }}
    >
      <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
      <Box sx={{ maxWidth: "70%", textAlign: "right" }}>
        {Array.isArray(value) ? (
          value.map((v, i) => (
            <Typography key={i} sx={{ fontSize: 14, textAlign: "justify" }}>
              {v.trim()}
            </Typography>
          ))
        ) : typeof value === "string" ? (
          <Typography sx={{ fontSize: 14, textAlign: "justify" }}>
            {value}
          </Typography>
        ) : (
          value
        )}
      </Box>
    </Box>
  );
};

const DetailsRow = ({ label, value }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        // py: 1.5,
        // borderBottom: "1px solid #dbe4ec",
      }}
    >
      <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{label}</Typography>
      <Box sx={{ maxWidth: "70%", textAlign: "right" }}>
        {typeof value === "string" ? (
          <Typography sx={{ fontSize: 12, textAlign: "justify" }}>
            {value}
          </Typography>
        ) : (
          value
        )}
      </Box>
    </Box>
  );
};
